import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { App } from "@/components/App/App";
import { MainPage } from "@/pages/main/MainPage";
import { PlaygroundPage } from "@/pages/playground/PlaygroundPage";
import { AdminPriceEdaPage } from "@/pages/adminPriceEda/AdminPriceEdaPage";
import ErrorFallback from "@/components/ErrorBoundary/ErrorFallback";

const routes = [
  {
    element: <App />,
    errorElement: <ErrorFallback />,
    children: [
      {
        path: "/",

        element: <MainPage />,
      },
      {
        path: "/admin/price-eda",
        element: <AdminPriceEdaPage />,
      },
    ],
  },
  {
    path: "/playground",
    element: <PlaygroundPage />,
  },
];

export const router = createBrowserRouter(routes);
